import React from 'react';
import { PanelHeader } from 'js/components';
import CoreWorkspaceSettingsContainer from '../containers/CoreWorkspaceSettingsContainer';
import ConnectorSettingsContainer from '../containers/ConnectorSettingsContainer';

function WorkspaceSettings({ workspace }) {
  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <CoreWorkspaceSettingsContainer workspace={workspace} />
        <ConnectorSettingsContainer workspace={workspace} />
      </div>
    </div>
  );
}

export default WorkspaceSettings;
